<template>
    <main class="main dashboard pt-lg-4 pt-3">
        <div class="container">
            <ui-slider
                v-if="topBanner"
                class="dashboard__banner"
                :content="topBanner"
            />

            <section class="mt-4 dashboard__sections" data-walk="1-1">
                <section class="dashboard__general mb-md-0 mb-3">
                    <div class="row row-cols-1 row-cols-lg-2">
                        <announcements-widget/>
                        <div
                            v-if="dashboardSnippets"
                            class="col mt-4 mt-lg-0 d-flex flex-column"
                        >
                            <dashboard-slider :data="dashboardSnippets" />
                        </div>
                    </div>
                </section>

                <m-kasa-widget
                    v-if="$store.getters.mKasaService"
                    class="dashboard__mKasaWidget mt-4 mb-lg-0 mb-4"
                />

                <section v-if="!isShopUser" class="dashboard__charts">
                    <div class="mt-4 mb-4 row row-cols-1 row-cols-lg-2">
                        <div class="col">
                            <dashboard-chart
                                v-if="receiptCount"
                                :chart-options="receiptCount"
                                custom-header-title="Liczba paragonów wystawionych w ostatnich 7 dniach"
                                :custom-header-subtitle="this.$brand.dashboard.statisticsDesc"
                                :is-custom-header="true"
                            />
                        </div>
                        <div class="col mt-4 mt-lg-0">
                            <dashboard-chart
                                v-if="receiptAmount"
                                :chart-options="receiptAmount"
                                custom-header-title="Wartość sprzedaży (zł) w ostatnich 7 dniach"
                                :custom-header-subtitle="this.$brand.dashboard.statisticsDesc"
                                :is-custom-header="true"
                            />
                        </div>
                    </div>
                </section>
                <section class="dashboard__summary mb-md-5 mb-2 mt-md-3 mt-0">
                    <div class="card-container row row-cols-1 row-cols-sm-2 row-cols-lg-4">
                        <div
                            v-for="(card, idx) in cards"
                            :key="idx"
                            class="
                                col col-md-6 col-xl-3
                                mb-3 mb-lg-0
                                mt-1 mt-lg-0
                            "
                        >
                            <dashboard-card :data="card" />
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </main>
</template>

<script>
import DashboardChart from '@/components/dashboard/DashboardChart'
import DashboardCard from '@/components/dashboard/DashboardCard'
import DashboardSlider from '@/components/dashboard/DashboardSlider'
import MKasaWidget from '@/components/reports/MKasaWidget'
import AnnouncementsWidget from '@/components/dashboard/AnnouncementsWidget.vue'

export default {
    created() {
        this.fetch()
    },
    components: {
        DashboardChart,
        DashboardCard,
        DashboardSlider,
        MKasaWidget,
        AnnouncementsWidget
    },
    computed: {
        receiptAmount() {
            return this.$store.getters.getReceiptAmount
        },
        receiptCount() {
            return this.$store.getters.getReceiptCount
        },
        companies() {
            return this.$store.getters.getCompaniesChart
        },
        cards() {
            return this.$store.getters.getDashboardCards
        },
        dashboardSnippets() {
            return this.$store.getters.getDashboardSnippets
        },
        isShopUser() {
            return this.$store.getters.isShopUser
        },
        topBanner() {
            return this.$store.getters.getDashboardTopBanner
        }
    },
    methods: {
        fetch() {
            this.$store.dispatch('receiptCountFetch')
            this.$store.dispatch('dashboardStatsFetch')
            this.$store.dispatch('dashboardInactiveServicesFetch')
            this.$store.dispatch('devicesFetch')

            this.$store.dispatch('snippetsLoad', {
                code: 'snippet001',
                moduleName: 'advertisements'
            })

            this.$store.dispatch('snippetsLoad', {
                code: 'snippet005',
                moduleName: 'advertisements'
            })
            this.$store.dispatch('snippetsLoad', {
                code: 'pwa.dashboard.proposed_service',
                moduleName: 'dashboard'
            })
        }
    }
}
</script>
